import { SortDescriptor } from "react-aria-components";

import { IDP_GROUP_ROLES_COLUMN_ID } from "../constants";
import { RoleBinding } from "../types";

export const sortRoles = (items: RoleBinding[], sortDescriptor: SortDescriptor) => {
  if (!sortDescriptor.column) {
    return items;
  }

  const isAscending = sortDescriptor.direction === "ascending";

  return [...items].sort((a, b) => {
    let valueA: string | undefined;
    let valueB: string | undefined;

    switch (sortDescriptor.column as IDP_GROUP_ROLES_COLUMN_ID) {
      case IDP_GROUP_ROLES_COLUMN_ID.NAME:
        valueA = a.role.name;
        valueB = b.role.name;
        break;
      case IDP_GROUP_ROLES_COLUMN_ID.GRANTED_AT:
        valueA = a.space.name;
        valueB = b.space.name;
        break;
      case IDP_GROUP_ROLES_COLUMN_ID.DESCRIPTION:
        valueA = "";
        valueB = "";
        break;
      case IDP_GROUP_ROLES_COLUMN_ID.DROPDOWN:
        valueA = "";
        valueB = "";
        break;
    }

    valueA = valueA || "";
    valueB = valueB || "";

    return isAscending ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
  });
};
